import api from '@/helpers/api';
import randomString from '@/helpers/randomString';
import { handleAssignmentActivity, handleFolderChange } from '../../../cache/conversationsCache';
import moment from '@/helpers/momentz';

let reloadFirstPageTimeout;

export default {
  fetchStatistics({ commit }, merchantId) {
    api('GET', `/merchants/${merchantId}/chat/statistics`)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_STATISTICS', {
            merchant_id: merchantId,
            data: response.data,
          });
          commit('UNREAD_CONVERSATIONS_COUNT', {
            merchant_id: merchantId,
            unread_conversations: {
              user_unread: response.data.open.user_unread,
              unassigned_unread: response.data.open.unassigned_unread,
              all_unread: response.data.open.all_unread,
            },
          });
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  // NOTE: Vedran, 2.6.2020. --> Not used anywhere... statistics are catched individually. See if it can be removed.
  setStatistics({ commit }, statistics) {
    // commit('SET_STATISTICS', statistics);
  },
  // deprecated
  fetchConversations({ commit }, payload) {
    commit('CONVERSATIONS_LOAD', {
      loaded: false,
      loading: true,
      page: payload.filters.page,
    });
    api('GET', `/merchants/${payload.merchant_id}/conversations`, { ...payload.filters, destination: 'universal' })
      .then((response) => {
        if (response.status === 200) {
          // response.data.forEach((conversation) => {
          // if (conversation.seen && conversation.message_unseen_count) {
          // conversation.message_unseen_count = 0;
          // }
          // });
          commit('SET_CONVERSATIONS', response.data);
          commit('CONVERSATIONS_LOAD', {
            loaded: true,
            loading: false,
            page: payload.filters.page,
          });
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchConversationsForInbox({ commit, rootGetters }, payload) {
    commit('MESSAGES_LOADED', false);
    commit('CONVERSATIONS_LOAD', {
      loaded: false,
      loading: true,
      page: payload.filters.page,
    });
    let endpoint;
    if (payload.businessId) {
      endpoint = `organisation/${payload.organisationId}/business/${payload.businessId}/conversation`;
    } else {
      endpoint = `organisation/${payload.organisationId}/conversation`;
    }
    api('GET', endpoint, { ...payload.filters, destination: 'universal' }, null, 'w')
      .then((response) => {
        if (
          response.status === 200 &&
          (rootGetters['organisation/currentNumber'] === null || rootGetters['organisation/currentNumber'] === payload.businessId)
        ) {
          response.data.data.forEach((conversation) => {
            if (conversation.seen && conversation.assignment_seen && conversation.message_unseen_count) {
              conversation.message_unseen_count = 0;
            }
          });
          commit('SET_CONVERSATIONS', response.data);
          commit('CONVERSATIONS_LOAD', {
            loaded: true,
            loading: false,
            page: payload.filters.page,
          });
          if (payload.saveFirstPage) {
            commit('SAVE_FIRST_PAGE_OF_CONVERSATIONS', {
              data: response.data.data,
              numberId: payload.businessId,
              folder: payload.filters.folder,
            });
          }
        }
      })
      .catch(() => { });
  },
  conversationCacheUpdate({ commit, dispatch, rootState, rootGetters }, payload) {
    const organisationId = rootState.organisation.currentOrganisation.id;
    handleFolderChange(commit, dispatch, rootState, rootGetters, organisationId, payload);
  },
  updateConversationCache({ commit }, data) {
    commit('UPDATE_FIRST_PAGE_OF_CONVERSATIONS', data);
  },
  populateConversationCache({ dispatch, rootState, getters }, numberId) {
    if (!getters.conversationFastReload[numberId] || !getters.conversationFastReload[numberId].open) {
      // get open
      dispatch(
        'silentFetchConversationsForInbox',
        {
          organisationId: rootState.organisation.currentOrganisation.id,
          filters: {
            noCancel: true,
            businessId: numberId,
            page: 1,
            limit: 25,
            folder: 'open',
          },
        },
      ).then((response) => {
        dispatch('updateConversationCache', { data: response.data.data, numberId, folder: 'open' });
      });
    }
    if (!getters.conversationFastReload[numberId] || !getters.conversationFastReload[numberId].done) {
      // get done
      dispatch(
        'silentFetchConversationsForInbox',
        {
          organisationId: rootState.organisation.currentOrganisation.id,
          filters: {
            noCancel: true,
            businessId: numberId,
            page: 1,
            limit: 25,
            folder: 'done',
          },
        },
      ).then((response) => {
        dispatch('updateConversationCache', { data: response.data.data, numberId, folder: 'done' });
      });
    }
  },
  clearConversationCache({ commit }) {
    commit('CLEAR_CONVERSATION_CACHE');
  },
  resetConversationsLoad({ commit }) {
    commit('CONVERSATIONS_LOAD', {
      loaded: false,
      loading: false,
      page: 1,
    });
  },
  removeMessageFromList({ commit }, messageSid) {
    commit('REMOVE_MESSAGE_FROM_LIST', messageSid);
  },
  addMessageToList({ commit }, payload) {
    commit('ADD_MESSAGE_TO_LIST', payload);
  },
  silentFetchConversationsForInbox(_, payload) {
    let endpoint = `organisation/${payload.organisationId}/conversation`;
    if (payload.filters.businessId) {
      endpoint = `organisation/${payload.organisationId}/business/${payload.filters.businessId}/conversation`;
    }
    delete payload.filters.businessId;
    const request = api('GET', endpoint, { ...payload.filters, destination: 'universal' }, null, 'w');
    return request;
  },
  fetchSingleConversation({ rootState }, payload) {
    const endpoint = `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.businessId}/conversation/${payload.conversationId}`;
    const request = api('GET', endpoint, { ...payload.filters, destination: 'universal' }, null, 'w');
    return request;
  },
  fetchMessages({ commit }, payload) {
    if (!payload.silent) {
      commit('API_ERROR', {});
      commit('MESSAGES_LOADING', true);
      commit('MESSAGES_LOADED', false);
    }
    const response = api('GET', `organisation/${payload.organisationId}/business/${payload.merchant_id}/conversation/${payload.conversation_id}/messages`, { ...payload.filters, destination: 'universal' }, null, 'w'); // destination is needed for the new format to be returned
    response
      .then((response) => {
        if (response.status === 200) {
          response.data.data.forEach((message) => {
            // neded for the media images
            message.loaded = false;
            if (!message.sid) {
              message.sid = randomString();
            }
          });
          if (!payload.silent) {
            commit('SET_MESSAGES', response.data);
            commit('MESSAGES_LOADED', payload.conversation_id);
          }
        }
      })
      .catch((error) => {
        commit('API_ERROR', error);
        commit('SET_MESSAGES', {});
        commit('MESSAGES_LOADING', false);
      })
      .finally(() => {
        if (!payload.silent) {
          commit('MESSAGES_LOADING', false);
        }
      });
    return response;
  },
  /**
   * Sets messages to the message list view when they are loaded from the fast reload cache.
   * @param payload Holds the messagesList object from the vuex store.
   */
  setMessages({ commit }, payload) {
    commit('SET_MESSAGES', payload);
  },
  clearMessageListMeta({ commit }) {
    commit('CLEAR_MESSAGE_LIST_META');
  },
  sendMessage({ commit }, payload) {
    payload.data.noCancel = true;
    api('POST', `organisation/${payload.organisationId}/business/${payload.businessId}/conversation/${payload.conversationId}/send-text-message`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('CONVERSATION_MESSAGE_SENT', {
            type: 'text',
            ref: true,
            sid: response.data.message_reference_id,
            temp_sid: payload.data.temp_sid,
            conversation_id: payload.conversationId,
          });
          commit('SENT_MESSAGE_STATUS_CHANGED', {
            sid: response.data.message_reference_id,
            // status: 'sent',
            conversation_id: payload.conversationId,
          });
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });

    // Also add the message to cache and messageList
    commit('ADD_MESSAGE', payload);
  },
  emojiReaction(_, payload) {
    const response = api('POST', `organisation/${payload.organisationId}/business/${payload.businessId}/conversation/${payload.conversationId}/send-text-message`, payload.data, null, 'w');
    return response;
  },
  emojiReactionReceived({ commit, dispatch }, payload) {
    payload.sender = payload.sender ? payload.sender : { name: 'contact' };
    commit('EMOJI_REACTION_RECEIVED', payload);
    dispatch('addReactionToFastLoad', payload);
  },
  updateMessageRef({ commit }, payload) {
    commit('SET_MESSAGE_REF', payload);
  },
  updateMessageSid({ commit }, payload) {
    commit('CONVERSATION_MESSAGE_SENT', payload);
  },
  // TODO - for v3 refactor create mixin for all message sending operations
  sendMedia({ commit }, payload) {
    api('POST', `/merchants/${payload.merchant_id}/conversations/${payload.conversation_id}/media`, payload.data, {
      'Content-Type': 'multipart/form-data',
    })
      .then((response) => {
        if (response.status === 200) {
          commit('CONVERSATION_MESSAGE_SENT', {
            type: 'file',
            sid: response.data.message_sid,
            temp_sid: payload.data.get('temp_sid'),
            media_url: response.data.media_url,
            conversation_id: payload.conversation_id,
          });
          commit('SENT_MESSAGE_STATUS_CHANGED', {
            sid: response.data.message_sid,
            status: 'sent',
            conversation_id: payload.conversation_id,
          });
        }
      })
      .catch((error) => {
        const errorData = error.response ? error.response : {
          status: 413,
          message: 'Request Entity too large.',
        };
        commit('FILE_UPLOAD_ERROR', {
          sid: payload.data.get('temp_sid'),
          error: errorData,
        });
      });
  },
  sendMediaV2({ commit, rootState }, payload) {
    payload.data.noCancel = true;
    api('POST', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/conversation/${payload.conversation_id}/send-media-message`, payload.data, {
      'Content-Type': 'multipart/form-data',
    }, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('CONVERSATION_MESSAGE_SENT', {
            type: 'file',
            ref: true,
            sid: response.data.message_reference_id,
            temp_sid: payload.data.get('temp_sid'),
            media_url: response.data.media_url,
            conversation_id: payload.conversation_id,
          });
          commit('SENT_MESSAGE_STATUS_CHANGED', {
            sid: response.data.message_sid,
            // status: 'sent',
            conversation_id: payload.conversation_id,
          });
        }
      });
  },
  // TODO switch to new endpoint
  reassignConversation({ commit }, payload) {
    api('PUT', `/merchants/${payload.merchant_id}/conversations/${payload.conversation_id}/assign`, { user_id: payload.user_id })
      .then((response) => {
        if (response.status === 200) {
          commit('CONVERSATION_REASSIGNED', payload);
          // also update conversation data
          commit('UPDATE_CONVERSATION_ASSIGNED_TO', { conversationId: payload.conversation_id, memberId: payload.user_id });
        }
      })
      .catch((error) => {
        payload.infoModal.show({ message: error.response.data.message, type: 'WARNING' });
        commit('API_ERROR', error.response);
      });
  },
  reassignConversationOrRevert({ commit, dispatch, rootGetters }, payload) {
    // update conversation data right away
    commit('UPDATE_CONVERSATION_ASSIGNED_TO', { conversationId: payload.conversationId, memberId: payload.outboundData.userId });
    // commit('ADD_MESSAGE', payload);
    commit('ADD_CONVERSATION_ACTIVITY', payload);
    if (payload.justLocally) { // when updating user on the frontend only. Backend will do this automatically if different user send a message to client.
      return;
    }
    // notify backend
    api('PUT', `organisation/${payload.outboundData.organisationId}/business/${payload.outboundData.businessId}/conversation/${payload.conversationId}/assign`, { user_id: payload.outboundData.userId }, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('CONVERSATION_REASSIGNED', payload.outboundData);
          const data = {
            business_uid: payload.outboundData.businessId,
            conversation_uid: payload.outboundData.conversationId,
            activity: {
              direction: 'activity',
              action: 'assignment',
              from_user_id: payload.outboundData.from_user_id,
              to_user_id: payload.outboundData.to_user_id,
              conversation_id: payload.outboundData.conversationId,
            },
          };
          handleAssignmentActivity(dispatch, rootGetters, payload.outboundData.organisationId, data);
        }
      })
      .catch((error) => {
        // revert conversation data
        commit('UPDATE_CONVERSATION_ASSIGNED_TO', { conversationId: payload.conversationId, memberId: payload.outboundData.revertUserId });
        commit('REVERT_CONVERSATION_ACTIVITY', payload);
        commit('API_ERROR', error.response);
      });
  },
  editActiveConversationData({ commit }, payload) {
    commit('EDIT_ACTIVE_CONVERSATION_DATA', payload);
  },
  unseenActiveConversation({ commit }) {
    commit('SET_CONVERSATION_SEEN_FOR_ACTIVE_CONVERSATION', false);
  },
  markConversationAsSeen({
    commit,
    dispatch,
    rootState,
    rootGetters,
  }, payload) {
    commit('SET_CONVERSATION_SEEN_FOR_ACTIVE_CONVERSATION', payload.data.seen);
    let conversationNumberUnreadCount = rootState.organisation.statistics[payload.merchant_id].open.all_unread;
    const userId = rootGetters['user/id'];
    const activeConversation = rootGetters['chat/activeConversation'];
    if (payload.data.seen && payload.folder === 'open') {
      // const userCounter = (activeConversation.user_id === userId) ? --rootState.organisation.statistics[payload.merchant_id].open.user_unread[userId] : rootState.organisation.statistics[payload.merchant_id].open.user_unread[userId];
      // dispatch('organisation/setNumberUnreadCounter', { counter: --conversationNumberUnreadCount, userCounter, numberId: payload.merchant_id }, { root: true });
      dispatch('organisation/decrementStatisticLocalData', {
        businessId: payload.merchant_id,
        conversationId: activeConversation.id,
        myChat: activeConversation.user_id === userId,
      }, { root: true });
    } else if (payload.folder === 'open') {
      // const userCounter = (activeConversation.user_id === userId) ? ++rootState.organisation.statistics[payload.merchant_id].open.user_unread[userId] : rootState.organisation.statistics[payload.merchant_id].open.user_unread[userId];
      // dispatch('organisation/setNumberUnreadCounter', { counter: ++conversationNumberUnreadCount, userCounter, numberId: payload.merchant_id }, { root: true });
      dispatch('organisation/incrementStatisticLocalData', {
        businessId: payload.merchant_id,
        conversationId: activeConversation.id,
        myChat: activeConversation.user_id === userId,
      }, { root: true });
    }
    commit('CONVERSATION_SEEN', false);
    const request = api('PUT', `organisation/${payload.organisationId}/business/${payload.merchant_id}/conversation/${payload.conversation_id}/seen`, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('CONVERSATION_SEEN', {
            business_uid: payload.merchant_id,
            conversation: {
              id: payload.conversation_id,
              seen: payload.data.seen,
              assignment_seen: payload.data.seen,
            },
          });
          // dispatch('organisation/fetchOrganisationNumberStatistics', { organisationId: payload.organisationId, businessId: payload.merchant_id, data: { sections: 'all_unread,user_unread' } }, { root: true }); // NOTE: We decided not to update statistics here but it is left here in case we change something.
          dispatch('organisation/resetLocalCounter', {
            businessId: payload.merchant_id,
            conversationId: payload.conversation_id,
          }, { root: true });
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return request;
  },
  changeFolder({ commit, rootState }, payload) {
    commit('CONVERSATION_FOLDER_CHANGED', false);
    const request = api('PUT', `/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.businessId}/conversation/${payload.conversationId}/change-folder`, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('CONVERSATION_FOLDER_CHANGED', {
            conversation_id: payload.conversation_id,
            folder: payload.data.folder,
          });
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });

    return request;
  },
  updateBotStatus({ commit, rootState }, payload) {
    commit('SET_BOT_STATUS_FOR_ACTIVE_CONVERSATION', payload);
    commit('BOT_STATUS_UPDATED', false);
    return api('PUT', `/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.businessId}/conversation/${payload.conversationId}/instant-replies/enable`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('BOT_STATUS_UPDATED', true);
          return Promise.resolve();
        }

        return Promise.reject();
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
        return Promise.reject(error);
      });
  },
  updateBotStatusLocally({ commit }, payload) {
    commit('SET_BOT_STATUS_FOR_ACTIVE_CONVERSATION', payload);
  },
  updateBotStatusForConversation({ commit }, payload) {
    commit('SET_BOT_STATUS_FOR_ACTIVE_CONVERSATION', payload);
  },
  fetchQuickReplies({ commit, rootState }) {
    commit('QUICK_REPLIES_LOADED', false);
    api('GET', `/organisation/${rootState.organisation.currentOrganisation.id}/quick-replies`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_QUICK_REPLIES', response.data);
          commit('QUICK_REPLIES_LOADED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  addQuickReply({ commit }, payload) {
    commit('QUICK_REPLY_CREATED', payload);
  },
  editQuickReply({ commit }, payload) {
    commit('QUICK_REPLY_UPDATED', payload);
  },
  deleteSingleQuickReply({ commit }, qrId) {
    commit('QUICK_REPLY_DELETED', qrId);
  },
  createQuickReply({ commit, rootState }, payload) {
    if (payload && payload.text) {
      payload.text = payload.text.replaceAll('{{contact name}}', '{{contact_name}}');
      payload.text = payload.text.replaceAll('{{number name}}', '{{business_name}}');
    }
    const request = api('POST', `/organisation/${rootState.organisation.currentOrganisation.id}/quick-replies`, payload, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('QUICK_REPLY_CREATED', {
            keyword: payload.keyword,
            text: payload.text,
            id: response.data.reply_uid,
            created_at: moment().unix(),
          });
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return request;
  },
  updateQuickReply({ commit, rootState }, payload) {
    if (payload.data && payload.data.text) {
      payload.data.text = payload.data.text.replaceAll('{{contact name}}', '{{contact_name}}');
      payload.data.text = payload.data.text.replaceAll('{{number name}}', '{{business_name}}');
    }
    const request = api('PUT', `/organisation/${rootState.organisation.currentOrganisation.id}/quick-replies/${payload.replyId}`, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('QUICK_REPLY_UPDATED', {
            keyword: payload.data.keyword,
            text: payload.data.text,
            id: payload.replyId,
          });
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return request;
  },
  deleteQuickReply({ commit, rootState }, replyId) {
    const request = api('DELETE', `/organisation/${rootState.organisation.currentOrganisation.id}/quick-replies/${replyId}`, null, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('QUICK_REPLY_DELETED', replyId);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return request;
  },

  clearChatData({ commit }) {
    commit('CLEAR_CHAT_DATA');
  },
  /**
   * Saves first page of messages to the fast reload cache.
   * NOTE - params are in the payload
   * @param conversationId Holds conversation id for which the message is received
   * @param messageList Holds all the messages available on the first page.
   */
  saveFirstPageOfMessages({ commit }, payload) {
    commit('SAVE_FIRST_PAGE_OF_MESSAGES', payload);
  },
  /**
   * Adds a new message to the fast reload cache. Max of 30 messages can be on one page so everything more than that is removed.
   * NOTE - params are in the payload
   * @param conversation Holds conversation object for which the message is received.
   * @param message Holds the messages to be added to the fast relaod cache.
   */
  addMessageToFastLoad({ commit, state }, payload) {
    // only add the message to the cache if the first page has been loaded to cache first
    if (state.chatFastReload[payload.conversation_uid]) {
      commit('ADD_MESSAGE_TO_CHAT_FAST_LOAD', payload);
    }
  },
  /**
   * Removes conversation from fast reload cache.
   * @param {*} payload Conversation to be removed.
   */
  removeFromFastLoad({ commit, state }, payload) {
    if (state.chatFastReload[payload.conversationId]) {
      commit('REMOVE_CONVERSATION_FROM_CHAT_FAST_LOAD', payload);
    }
  },
  removeMessageFromFastReload({ commit, state }, payload) {
    if (state.chatFastReload[payload.conversationId]) {
      commit('REMOVE_MESSAGE_FROM_CHAT_FAST_LOAD', payload);
    }
  },
  addReactionToFastLoad({ commit, state }, payload) {
    if (state.chatFastReload[payload.conversationId]) {
      commit('ADD_REACTION_TO_CHAT_FAST_LOAD', payload);
    }
  },
  clearFastReload({ commit }) {
    commit('CLEAR_FAST_RELOAD');
  },
  reloadFirstPage({ commit }) {
    clearTimeout(reloadFirstPageTimeout);
    reloadFirstPageTimeout = setTimeout(() => {
      commit('RELOAD_FIRST_PAGE');
    }, 60000);
  },
  setActiveConversation({ commit }, conversation) {
    commit('SET_ACTIVE_CONVERSATION', { ...conversation });
  },
  setCurrentConversationLastInbound({ commit }, payload) {
    commit('SET_CURRENT_CONVERSATION_INBOUND', payload);
  },
  /** Added when initiating new conversation with number not already on the contact list. */
  addTempConversation({ commit }, conversation) {
    commit('ADD_CONVERSATION_TO_TOP', conversation);
  },
  setSearchAllNumbersButton({ commit }, status) {
    commit('SET_SEARCH_ALL_NUMBERS_BUTTON', status);
  },
  updateConversationContact({ commit }, payload) {
    commit('UPDATE_CONVERSATION_CONTACT', payload);
  },
  removeConversationFromList({ commit }, conversation) {
    commit('REMOVE_CONVERSATION_FROM_LIST', conversation);
  },
  setStartNewConversationSelectId({ commit }, id) {
    commit('SET_START_NEW_CONVERSATION_SELECT_ID', id);
  },
  setStartNewConversation({ commit }, number) {
    commit('START_CONVERSATION_WITH', number);
  },
  addNewTempConversation({ commit }, conversation) {
    commit('ADD_NEW_TEMP_CONVERSATION', conversation);
  },
  removeNewTempConversation({ commit }, conversation) {
    commit('REMOVE_NEW_TEMP_CONVERSATION', conversation);
  },
  setAllowEnter({ commit }, status) {
    commit('SET_ALLOW_ENTER', status);
  },
  enterPressed({ commit }) {
    commit('ENTER_PRESSED');
  },
  setFolder({ commit }, folder) {
    commit('SET_FOLDER', folder);
  },
  setShowEmptyDone({ commit }, status) {
    commit('SET_SHOW_EMPTY_DONE', status);
  },
  setShowEmptyOpen({ commit }, payload) {
    commit('SET_SHOW_EMPTY_OPEN', payload);
  },
  setForceConversationLoadSpinner({ commit }, status) {
    commit('FORCE_CONVERSATION_LOAD_SPINNER', status);
  },
  resetConversationList({ commit }, flag) {
    commit('RESET_CONVERSATION_LIST', flag);
  },
  enableConsent({ commit }, payload) {
    payload.consent = true;
    commit('SET_CONSENT', payload);
  },
  disableConsent({ commit }, payload) {
    payload.consent = false;
    commit('SET_CONSENT', payload);
  },
  updateInputMessage({ commit }, message) {
    commit('UPDATE_INPUT_MESSAGE', message);
  },
  clearInputMessage({ commit }) {
    commit('CLEAR_INPUT_MESSAGE');
  },
  updateConversations({ commit }, payload) {
    commit('UPDATE_CONVERSATIONS', payload);
  },
  backupOutboundMessage({ commit }, payload) {
    commit('BACKUP_OUTBOUND_MESSAGE', payload);
  },
  clearOutboundMessage({ commit }, conversationId) {
    commit('CLEAR_OUTBOUND_MESSAGE', conversationId);
  },
};
